import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import Divider from '../Divider';
import OptionPropType from '../../prop-types/DropdownOption';
import styles from './dropdown.css';
var cx = classnames.bind(styles);
export default function DropdownOption(_ref) {
  var disabled = _ref.disabled,
      isLast = _ref.isLast,
      isSelected = _ref.isSelected,
      noOptionsMessage = _ref.noOptionsMessage,
      option = _ref.option,
      rest = _objectWithoutProperties(_ref, ["disabled", "isLast", "isSelected", "noOptionsMessage", "option"]);

  return React.createElement(React.Fragment, null, React.createElement("li", _extends({
    "aria-selected": isSelected,
    className: cx('option', {
      disabled: disabled,
      selected: isSelected
    }),
    role: "option"
  }, rest), ((option === null || option === void 0 ? void 0 : option.render) ? option.render(option.label) : option === null || option === void 0 ? void 0 : option.label) || noOptionsMessage), !isLast && React.createElement(Divider, {
    className: styles.itemDivider
  }));
}
DropdownOption.propTypes = {
  disabled: PropTypes.bool,
  isLast: PropTypes.bool,
  isSelected: PropTypes.bool,
  noOptionsMessage: PropTypes.string,
  option: OptionPropType
};
DropdownOption.defaultProps = {
  disabled: false,
  isLast: false,
  isSelected: false,
  noOptionsMessage: 'No options available',
  option: undefined
};